export function ScrollButton({handleClick, toShow= false}) {
  return (
    <button className={`scroll-button ${toShow ? 'd-block': 'd-none'}`} onClick={handleClick}>
      <i className="bi bi-arrow-up-short"></i>
    </button>
  );
};